import { render, staticRenderFns } from "./ConsultarPersonas.vue?vue&type=template&id=cea5252e"
import script from "./ConsultarPersonas.vue?vue&type=script&lang=js"
export * from "./ConsultarPersonas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports